<div class="wrapper">
    <canvas #chartCanvas></canvas>
</div>
